module.exports = __webpack_public_path__ + "img/government_qinghai.3f3160d1.png";